import React from 'react'

import { Dialog } from 'primereact/dialog'
import DialogFooter from '../../dialogFooter'
import CentralService from '../../../app/service/central/centralService'
import GeneralServices from '../../../app/service/generalServices'
import HandleErrorService from '../../../app/service/handleErrorService'
import ProvisaoService from '../../../app/service/contasAPagar/provisaoService'
import LancamentoProvisaoComponent from './lancamentoProvisaoComponent'
import { ProgressSpinner } from 'primereact/progressspinner'
import ItensNFComponent from '../../nf/itensNFComponent'
import * as popUp  from '../../toastr'
import ConstantsUtil from '../../../context/constantsUtil'
import AuthService from '../../../app/service/authService'
import { Button } from 'primereact/button'
import ProvisaoRecebimentoService from '../../../app/service/contasAReceber/provisaoRecebimentoService'

class EditProvisaoDialog extends React.Component {

    constructor(){
        super()
        this.centralService = new CentralService();
        this.provisaoService = new ProvisaoService();
        this.provisaoRecebimentoService = new ProvisaoRecebimentoService();
        this.lancamentoProvisaoComponentRef = React.createRef();
    }

    state = {
        
        didUpdated: false,
        loading: false,

        provisaoToEdit: '',

        provisoesRecorrentesFuturas: [],
        displayConfirmEditRecorrenciaDialog: false,


        
    }

    componentDidUpdate(){
        if( this.props.visible && !this.state.didUpdated ){
            this.searchProvisao()
            this.setState({didUpdated: true})
        }
    }
    
    reRender = async () => {
        /*
        Foi necessário para que os subdialogs abram corretamente dentro do DRE.
        */
        if(this.props.reRender){
            this.props.reRender()
        }
    }

    resetView = () => {
        this.setState({provisaoToEdit: ''})
    }

    searchProvisao = () => {
        // console.log("search: ", this.props.provisaoId)
        this.resetView()
        this.setState({loading: true})
        this.resolveSearchProvisao()
        .then(response => {
            this.trataDados(response.data)
        })
        .catch(error => {
            // console.log("error: ", error)
            HandleErrorService.handleError(error)
        })
        .finally(() => {
            this.setState({loading: false})
        })
    }

    resolveSearchProvisao = () => {
        if(this.props.provisaoId){
            if(this.props.empresa){
                return this.centralService.searchProvisaoByIdAndEmpresa(this.props.provisaoId, this.props.empresa.id)
            }
            else{
                return this.provisaoService.searchById(this.props.provisaoId)
            }
        }
        else if(this.props.provisaoRecebimentoId){
                return this.provisaoRecebimentoService.searchById(this.props.provisaoRecebimentoId)
        }
        else if(this.props.notaFiscal){
            // console.log("this.props.tipoNotaFiscal: ", this.props.tipoNotaFiscal)
            switch(this.props.tipoNotaFiscal){
                case ConstantsUtil.tipoNotaFiscalMercadoria:
                    return this.provisaoService.searchByNFId(this.props.notaFiscal.id)
                case ConstantsUtil.tipoNotaFiscalServico:
                    return this.provisaoService.searchByNFSeId(this.props.notaFiscal.id)

            }
        }
    }    

    trataDados = async (provisao) => {

        if(provisao.dataLancamento){
            /*
            Provisões de NF não validadas não possuem data de lançamento
            */
            provisao.dataLancamentoView = GeneralServices.convertBrStringToJsDate(provisao.dataLancamento)
        }
        provisao.parcelaProvisaoList.forEach(parcela => {
            parcela.dataView = GeneralServices.convertBrStringToJsDate(parcela.data)
        })

        // console.log("provisaoToEdit: ", provisao)
        await this.setState({provisaoToEdit: provisao})
        if(this.isProvisaoFromNFNaoValidada()){
            popUp.infoPopUp("Nota Fiscal ainda não validada!")
        }
    }

    isProvisaoFromNFNaoValidada = () => {
        let result = this.state.provisaoToEdit && this.state.provisaoToEdit.notaFiscal && this.state.provisaoToEdit.notaFiscal.pendente
        // console.log("result: ", result)
        return result
    }

    hideDialog = (body) => {
        this.props.hideDialog(body)
        this.setState({didUpdated: false})
    }

    onCallEdit = () => {
        this.hideDialog({isAfterEdit: true})
        if(this.props.startLoadingTable){
            this.props.startLoadingTable()
        }
        
    }

    onSuccessEdit = () => {
        this.props.search(true)
    }

    onErrorEdit = () => {
        if(this.props.finishLoadingTable){
            this.props.finishLoadingTable()
        }
    }

    callSave = () => {
        // console.log("callSave this.props.provisaoToEdit: ", this.state.provisaoToEdit)
        if(this.state.provisaoToEdit.uuidRecorrencia){
            this.callEditProvisaoRecorrente()
        }
        else{
            this.confirmEdit()       
        }
    }

    confirmEdit = (uuidRecorrencia) => {
        this.lancamentoProvisaoComponentRef.current.callSave(uuidRecorrencia)
        this.hideConfirmEditRecorrenciaDialog()
    }

    callEditProvisaoRecorrente = () => {
        this.provisaoService.buscaProvisoesRecorrentesFuturas(this.state.provisaoToEdit.id)
        .then(response => {
            // console.log("response: ", response.data)
            this.setState({
                provisoesRecorrentesFuturas: response.data.provisaoList,
                displayConfirmEditRecorrenciaDialog: true
            })
        })
        .catch(error => {
            HandleErrorService.handleError(error)
        })
    }

    hideConfirmEditRecorrenciaDialog = () => {
        this.setState({
            provisoesRecorrentesFuturas: [],
            displayConfirmEditRecorrenciaDialog: false
        })        
    }

    disableFooter = () => {
        return this.isProvisaoFromNFNaoValidada() || AuthService.getPerfil().isAlmoxarife
    }

    handleTipoProdutoChange = (index, selectedTipoProduto, attribute) => {

        /*
        attribute pode ser tipoProduto ou tipoEstoque ou tipoProdutoContaGerencial
        */

        let provisaoToEdit = this.state.provisaoToEdit
        let transactionList = provisaoToEdit.notaFiscal.transactions
        let transaction = transactionList[index]
        // console.log("transaction: ", transaction)
        transaction[attribute] = selectedTipoProduto
        
        this.setState({provisaoToEdit})
    }

    render(){

        
        const footer = (
            <DialogFooter save = {this.callSave} hideDialog = {this.hideDialog} disabled={this.disableFooter()}
            />
        )

        const renderDialog = () => {
            if(this.state.loading){
                return (
                    <Dialog
                        visible
                    >
                        <ProgressSpinner className='custom-progress-spinner'/>
                    </Dialog>                      
                )
            }
            else{
                return (
                    <Dialog
                        visible={this.props.visible}
                        style={{ width: '95vw'}}
                        header="Editar Provisão"
                        modal
                        className="p-fluid"
                        footer={footer}
                        onHide={this.hideDialog}
                    >
                    <div className='col-md-12'> 
                        <LancamentoProvisaoComponent
                            ref={this.lancamentoProvisaoComponentRef}
                            insideEditDialog
                            provisao={this.state.provisaoToEdit}
                            isProvisaoAReceber={!!this.props.provisaoRecebimentoId}
                            isProvisaoAPagar={!this.props.provisaoRecebimentoId}
                            empresa={this.props.empresa}
                            onSuccessEdit={this.onSuccessEdit}
                            onCallEdit={this.onCallEdit}
                            onErrorEdit={this.onErrorEdit}
                            disabled={this.isProvisaoFromNFNaoValidada()}
                            research={this.searchProvisao}
                            reRenderEditDialog={this.reRender}
                            insideDre={this.props.insideDre}
                            unificar={this.props.unificar}
                        />
                    </div>
                    <ItensNFComponent
                        transactions={this.state.provisaoToEdit && this.state.provisaoToEdit.notaFiscal ? this.state.provisaoToEdit.notaFiscal.transactions : []}
                        insideEditProvisaoDialog
                        research={this.searchProvisao}
                        disabled={this.isProvisaoFromNFNaoValidada()}
                        reRenderEditDialog={this.reRender}
                        handleTipoProdutoChange={this.handleTipoProdutoChange}
                    />
    
                    </Dialog>
                )
            }
        }

        const confirmEditProvisaoRecorrenteFooter = () => {
            return (
                <>
                    <Button
                        label="Manter como recorrente/estimativa"
                        onClick={() => this.confirmEdit(this.state.provisaoToEdit.uuidRecorrencia)}
                    />
                    <Button
                        label="Marcar como definitiva"
                        className="right-button p-button-danger"
                        onClick={() => this.confirmEdit()}
                    />
                </>
            )
        }        

        const renderConfirmEditProvisaoRecorrenteDialog = () => {
            return(
                    <Dialog
                        visible={this.state.displayConfirmEditRecorrenciaDialog}
                        style={{ width: '40vw'}}
                        header="Editar Provisão Recorrente"
                        modal
                        className="p-fluid"
                        footer={confirmEditProvisaoRecorrenteFooter}
                        onHide={this.hideConfirmEditRecorrenciaDialog}
                    >
                    <div className='col-md-12'>
                            Essa é uma provisão recorrente/estimativa.
                            <br />
                            Deseja manter como recorrente/estimativa ou marcar como definitiva?
                            <br />
                            As demais provisões dessa recorrência possuem as seguintes datas de pagamento:
                            <br />
                            {GeneralServices.getDatasPagamentosRecorrenciasFuturas(this.state.provisoesRecorrentesFuturas)}
                    </div>
                    </Dialog>
            )
        }


        return(
            <>
                {renderDialog()}
                {renderConfirmEditProvisaoRecorrenteDialog()}
            </>
        )
    }

}

export default EditProvisaoDialog